module.exports = __webpack_public_path__ + "static/media/black-amex.b0a550fb.svg";